import produce from 'immer';

import { convertedScheduleTiers } from 'bundles/backoffice/helpers/royalties';

import {
  SAVE_STARTED,
  SET_ERRORS,
  SET_SCHEDULE,
} from './actions';

const emptyState = {
  defaultRoyaltyPatterns: [],
  errors: [],
  schedules: [],
  saving: false,
};

export default produce((state, action) => {
  switch (action.type) {
  case SAVE_STARTED:
    state.saving = true;
    break;
  case SET_ERRORS:
    state.errors = action.errors;
    break;
  case SET_SCHEDULE: {
    state.saving = false;

    const index = state.schedules.findIndex(schedule => schedule.id === action.schedule.id);
    const convertedTiers = convertedScheduleTiers(action.schedule, state.defaultRoyaltyPatterns);
    const newSchedule = { ...action.schedule, tiers: convertedTiers };

    if (index > -1) {
      state.schedules[index] = newSchedule;
    } else {
      state.schedules.push(newSchedule);
    }
    break;
  }
  }
}, emptyState);
